<div class="mb-5">
	<h1 class="h3 m-4">{{'utilization.site_energy_usage_score' | translate}} <app-help-tooltip [field]="'site_fleet_energy_utilization_score'"></app-help-tooltip></h1>
	<app-score-chart
		*ngIf="data"
		[data]="data"
		[devices]="devices"
		chartType="fleet_energy_usage_score"
		[daysFilterSelected]="selectedDaysFilter"
		[periodSelected]="selectedPeriod"
		[truckTypeSelected]="selectedTruckType"
		[hideFilters]="hideFilters"
	></app-score-chart>
</div>
